import { useMutation, useQueryClient } from '@tanstack/react-query'
import { createOverrideRule } from '../../../api/plan-benefit-override-rules-api'
import type {
  CreatePlanBenefitOverrideRuleRequestDto,
  PlanBenefitOverrideRuleResponseDto,
} from '../../../api/dto/plan-benefit-override-rules.dto'
import { OVERRIDE_RULES_QUERY_KEY } from '../pages/ListPlanBenefitOverride/hooks/useGetOverrideRules'

export function useCreateOverrideRule() {
  const queryClient = useQueryClient()

  return useMutation<
    PlanBenefitOverrideRuleResponseDto,
    unknown,
    CreatePlanBenefitOverrideRuleRequestDto
  >({
    mutationFn: (body) => createOverrideRule(body),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: [OVERRIDE_RULES_QUERY_KEY] })
    },
  })
}
